export const X_AMZ_ALGORITHM = 'AWS4-HMAC-SHA256';
export const AMZ_SCOPE_REQUEST_NAME = 'aws4_request';
export const AMZ_SIGNING_KEY_PREFIX = 'AWS4';
export const UNSIGNED_PAYLOAD_HASH = 'UNSIGNED-PAYLOAD';

export const AMZ_SIGN_HEADERS = {
  XAmzAlgorithm: 'X-Amz-Algorithm',
  XAmzCredential: 'X-Amz-Credential',
  XAmzDate: 'X-Amz-Date',
  XAmzExpires: 'X-Amz-Expires',
  XAmzSignedHeaders: 'X-Amz-SignedHeaders',
  XAmzSecurityToken: 'X-Amz-Security-Token',
};
